module.exports = __webpack_public_path__ + "static/media/Noirden-SemiBold-oblique.9d416e19.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-SemiBold-oblique.eot
// module id = 2877
// module chunks = 71